import { reduxToastAction, ToastData } from "../types";

const initalState: ToastData = {
  show: false,
  text: "",
  heading: "",
  type: "info",
};

const toastReducer = (state = initalState, action: reduxToastAction) => {
  switch (action.type) {
    case "UPDATE_TOAST":
      return action?.payload;
    default:
      return state;
  }
};

export default toastReducer;
